import { Currency } from './currency';

// Types of assets
export type AssetType = 'fiat' | 'token' | 'nft';

export interface AssetBaseDto {
  type: AssetType;
  amount: string;
  precision: number; // The number of decimal places for formatting `amount` in the UI
}

export interface FiatAssetDto extends AssetBaseDto {
  type: 'fiat';
  ticker: Currency; // e.g. 'USD'
  symbol: string; // e.g. '$'
  name: string; // e.g. 'US Dollar'
}
export const FIAT_ASSET_IDENTIFIER_KEY = 'ticker';
export const FIAT_ASSET_NAME_KEY = 'name';
export const FIAT_ASSET_SYMBOL_KEY = 'symbol';

export interface TokenAssetDto extends AssetBaseDto {
  type: 'token';
  ticker: string; // e.g. 'ETH'
  symbol?: string; // e.g. 'Ξ'
  name?: string; // e.g. 'Ether'
  imageUrl?: string;
  tokenId?: number;
}
export const TOKEN_ASSET_IDENTIFIER_KEY = 'tokenId';
export const TOKEN_ASSET_NAME_KEY = 'name';
export const TOKEN_ASSET_SYMBOL_KEY = 'ticker';
export const TOKEN_ASSET_IMAGE_KEY = 'imageUrl';

export interface NftAssetCollectionDto {
  name: string; // e.g. 'Mythics Eggs'
  imageUrl?: string;
}
export interface NftAssetContractDto {
  symbol?: string; // e.g. 'EGG'
}
export interface NftAssetDto extends AssetBaseDto {
  type: 'nft';
  nft: {
    id: string;
    tokenId?: string; // e.g. "1099"
    name?: string; // e.g. "Egg #1099"
    imageUrl?: string;
    collection: NftAssetCollectionDto;
    contract: NftAssetContractDto;
  };
}
export const NFT_ASSET_COLLECTION_IDENTIFIER_KEY = 'nft.collection.id';
export const NFT_ASSET_COLLECTION_NAME_KEY = 'nft.collection.name';
export const NFT_ASSET_IDENTIFIER_KEY = 'nft.id';
export const NFT_ASSET_NAME_KEY = 'nft.name';
export const NFT_ASSET_IMAGE_KEY = 'nft.imageUrl';
export const NFT_ASSET_SYMBOL_KEY = 'nft.contract.symbol';

export type AssetDto = FiatAssetDto | TokenAssetDto | NftAssetDto;
